import { OneActorSettingT } from 'shared/api/types/services';
import ModelInfo, { InfoBoxesT } from 'shared/components/ModelInfo';

interface Props {
  data: OneActorSettingT['response'];
}

const Info = ({ data }: Props) => {
  const infoBoxes: InfoBoxesT = [
    {
      label: 'Name',
      type: 'text',
      value: data.name,
    },
    {
      label: 'Text',
      type: 'text',
      value: data.text,
    },
    {
      label: 'Description',
      type: 'text',
      value: data.description,
    },
  ]

  return (
    <ModelInfo infoBoxes={infoBoxes} />
  );
};

export default Info;
